export default __webpack_public_path__ + "static/media/sec4contentimg3.850686d0.png";